import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LibConfig } from '../models/lib-config.model';
import { HandshakeService } from './handshake.service';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { LIB_CONFIG } from '../lib-config';

@Injectable({
  providedIn: 'root',
})
export class ManageTransactionDataService {
  private baseUrl: string;
  constructor(
    private http: HttpClient,
    private handshakeService: HandshakeService,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {
    this.baseUrl = this.config?.apigeeApi?.baseUrl;
  }

  retrieve(token: any) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi?.manageTransactionData?.retrieve}`;
        const body = {
          transactionKey: token,
        };
        return this.http.post(apiURL, body, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  create(name: string, value: string) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.baseUrl}${this.config.compaxAngularApi?.manageTransactionData?.create}`;
        const body = {
          payload: [
            {
              name,
              value,
            },
          ],
        };
        return this.http.post(apiURL, body, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      })
    );
  }

  priorityCall(wid: string, actionRef: string, nextAction: string, tid?: number) {
    if (tid) {
      // TODO: Maybe move to environmental config...
      let transactionContext = 'Broadband_IVR_Handback';
      if (this.config?.appName === 'tv-fault') {
        transactionContext = 'FixTVissues_IVR_Handback';
      }
      return this.handshakeService
        .getAuthorizationHeaders()
        .pipe(
          mergeMap((authorizationHeaders: any) => {
            const apiURL = `${this.baseUrl}${this.config.compaxAngularApi?.manageTransactionData?.create}`;
            const body = {
              payload: [
                { name: 'tid', value: tid },
                { name: 'wid', value: wid },
                { name: 'ActionRef', value: actionRef },
                { name: 'NextAction', value: nextAction },
              ],
              primaryDataReference: 'Web2IVR',
              transactionContext,
            };
            return this.http.post(apiURL, body, authorizationHeaders).pipe(
              mergeMap((results: any) => {
                return of(results);
              })
            );
          })
        )
        .subscribe((results) => {
          return of(results);
        });
    }
  }

  wifiMaxCall(wid: string, actionRef: string, nextAction: string, tid?: number) {
    if (tid) {
      return this.handshakeService
        .getAuthorizationHeaders()
        .pipe(
          mergeMap((authorizationHeaders: any) => {
            const apiURL = `${this.baseUrl}${this.config.compaxAngularApi?.manageTransactionData?.create}`;
            const body = {
              payload: [
                { name: 'tid', value: tid },
                { name: 'wid', value: wid },
                { name: 'ActionRef', value: actionRef },
                { name: 'NextAction', value: nextAction },
              ],
              primaryDataReference: 'Web2IVR',
              transactionContext: 'WiFiMax_IVR_Handback',
            };
            return this.http.post(apiURL, body, authorizationHeaders).pipe(
              mergeMap((results: any) => {
                return of(results);
              })
            );
          })
        )
        .subscribe((results) => {
          return of(results);
        });
    }
  }
}
